import { useTypedSelector } from ".";

export const useIsUserLoggedIn = (): boolean =>
  useTypedSelector(state => !!state.user.data);
